import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiSlider = (baseTheme: Theme): Partial<Components> => ({
  MuiSlider: {
    styleOverrides: {
      root: {
        color: baseTheme.palette.brand.main,
      },
      valueLabel: {
        color: baseTheme.palette.brand.main,
      },
      rail: {
        height: '3px',
        color: baseTheme.palette.grey[300],
      },
      track: {
        height: '3px',
      },
      thumb: {
        height: '11px',
        width: '11px',
        marginTop: '0',
        '&.Mui-disabled': {
          marginTop: '-1px',
        },
      },
    },
  },
});
